import { render, staticRenderFns } from "./PagibigContributionDetails.vue?vue&type=template&id=d513fe2c&scoped=true"
import script from "./PagibigContributionDetails.vue?vue&type=script&lang=js"
export * from "./PagibigContributionDetails.vue?vue&type=script&lang=js"
import style0 from "./PagibigContributionDetails.vue?vue&type=style&index=0&id=d513fe2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d513fe2c",
  null
  
)

export default component.exports